import { EducationRoute } from '@/modules/education/v1/api/EducationRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { SaveAnswerParams } from '@/modules/education/v1/api/v1/packs/Dto/SaveAnswerParams'
import { AnswerRecord } from '@/modules/education/v1/api/v1/packs/Dto/AnswerRecord'
import { OFFLINE_NODE } from '@/modules/education/v1/api/v1/packs/GetPack/GetPackRoute'

/** POST /api/education/v1/packs/{pack}/answers: факт ответа; ошибки already_answered, question_not_in_pack, not_found */
export class SaveAnswerRoute extends EducationRoute<SaveAnswerParams, AnswerRecord> {
  constructor(private readonly pack: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.POST
  }

  url(): string {
    return '/api/education/v1/packs/' + this.pack + '/answers'
  }

  offline(params: SaveAnswerParams): Promise<ApiResponse<AnswerRecord>> {
    const at = new Date().toISOString()
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new AnswerRecord({ time: at, at, question: params.question, node: OFFLINE_NODE, result: params.result, ms: params.ms, pack: this.pack }),
    }))
  }
}
